
import RouterConfig from './router/RouterConfig';

function App() {
  return <RouterConfig />;
}

export default App;